import styled from 'styled-components';
import { GoInfo } from 'react-icons/go';
import { color } from '~/assets/styles/colors';

export const DivMontante = styled.div`
	display: flex;
	margin: 0px;
	flex-direction: row;
	justify-content: center;
`;

export const ImgMontante = styled.img`
	margin-left: 10px;
	filter: brightness(0);
`;

export const TextMontante = styled.div`
	font-size: 2vw;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	@media (max-width: 580px) {
		font-Size: 18px;
	}
`;

export const FlexMontante = styled.div`
	magin: 0px;
	width: 100%;
	padding: 0px;
	display: flex;
`;

export const Info = styled(GoInfo)`
	font-size: 13px;
	margin:  0 0 2px 2px;
	cursor: pointer;
	color: ${color.red};

	@media (max-width: 1080px) {
		font-Size: 10px;
	}
`;

export const TitleMontante = styled.div`
	font-size: 0.8vw;
	font-weight: bold;
	padding: 0px 0px 4px 0px;

	@media (max-width: 580px) {
		font-Size: 13px;
	}
`;


export const TitleSecondValue = styled.div`
	font-size: 0.8vw;
	font-weight: bold;
	height: 1.2vw;
	padding: 0px 10px 0px 10px;
	text-align: center;
	background-color: white;

	@media (max-width: 580px) {
		font-Size: 13px;
		height: 15px;
	}
`;
